var _g, _g2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBridgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 105,
    viewBox: "0 0 114 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11_504)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.9414,
    y: 11,
    width: 72.9615,
    height: 73.8073,
    rx: 4,
    fill: "url(#paint0_linear_11_504)",
    fillOpacity: 0.15,
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_df_11_504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6233 10.2154C10.9133 16.3804 7.98207 29.3403 14.0774 39.1624C20.1728 48.9845 32.9812 51.9492 42.6913 45.7842C52.4013 39.6192 55.3325 26.6593 49.2372 16.8372C43.1418 7.01563 30.3334 4.05092 20.6233 10.2154Z",
    fill: "url(#paint1_radial_11_504)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3249 29.5C60.3249 28.1193 47.2686 27 31.1629 27C15.0572 27 2.00098 28.1193 2.00098 29.5",
    stroke: "url(#paint2_linear_11_504)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.161 55.5169C108.964 59.3476 106.875 62.7526 105.054 66.2641C104.571 67.2218 104.357 68.6051 104.625 69.6159C107.518 80.6291 110.518 91.6423 113.464 102.655C113.625 103.294 113.786 103.986 114 104.943C110.732 104.943 107.786 105.05 104.786 104.837C104.25 104.784 103.446 103.773 103.286 103.028C101.304 96.0582 99.4821 89.0885 97.5536 82.1188C97.3929 81.5868 97.2321 81.0547 96.9643 80.2035C96.2679 81.3739 95.7321 82.2252 95.1964 83.1297C91.2857 89.8865 87.3214 96.5902 83.4107 103.4C82.7679 104.518 82.0714 104.996 80.7321 104.943C77.625 104.837 74.5179 104.89 70.9821 104.89C71.5179 103.879 71.8929 103.134 72.3214 102.389C78.9643 90.9506 85.5536 79.565 92.25 68.1794C93 66.9025 93.2143 65.8385 92.7857 64.402C91.7143 60.8373 90.8036 57.1663 89.6786 53.0696C89.0893 54.0804 88.6607 54.7189 88.2857 55.3573C79.0179 71.2652 69.8036 87.12 60.5893 103.081C59.7857 104.518 58.875 105.05 57.2143 104.996C54.2679 104.837 51.2679 104.943 48 104.943C48.4821 103.986 48.8571 103.294 49.2321 102.655C61.1786 82.1188 73.125 61.6354 84.9643 41.0987C85.875 39.5026 86.8393 38.8642 88.6607 39.0238C90.5893 39.1834 92.5179 39.1302 94.4464 39.0238C95.7857 38.9706 96.4286 39.343 96.8036 40.7795C97.875 45.089 99.1607 49.3985 100.286 53.708C100.607 55.0381 101.196 55.5701 102.589 55.5169C105.268 55.4105 108 55.5169 111.161 55.5169Z",
    fill: "url(#paint3_linear_11_504)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11_504",
    x: 17.9414,
    y: 5,
    width: 92.9614,
    height: 93.8073,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_504"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_504",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_df_11_504",
    x: 0.897949,
    y: 0,
    width: 61.5186,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11_504"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11_504",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    result: "effect2_foregroundBlur_11_504"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11_504",
    x1: 104.916,
    y1: 121.711,
    x2: -15.5769,
    y2: -61.5381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11_504",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7404 46.2) rotate(-58.4865) scale(46.9635 46.7211)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF89E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#92D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991368,
    stopColor: "#89A7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11_504",
    x1: -6.40162,
    y1: 30,
    x2: 94.4362,
    y2: 24.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44B4DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "white",
    stopOpacity: 0.557292
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44B4DF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11_504",
    x1: 80.9999,
    y1: 127.418,
    x2: 80.9999,
    y2: 21.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5B86E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D1DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeIcon);
export default __webpack_public_path__ + "static/media/bridge-icon.51ef08f46bb4e3b06b1775b6c7c45a55.svg";
export { ForwardRef as ReactComponent };